import { fetchHourlyCSVActions } from "./actions";

let initialState = {
  pickerReportSuccess: null,
  pickerReportError: null,
  checkerReportSuccess: null,
  checkerReportError: null,
};

export const pickerCheckerReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchHourlyCSVActions.FETCH_PICKERREPORT_SUCCESS:
      return {
        ...state,
        pickerReportSuccess: action.payload,
        pickerReportError: null,
      };
    case fetchHourlyCSVActions.FETCH_PICKERREPORT_FAILURE:
      return {
        ...state,
        pickerReportSuccess: null,
        pickerReportError: action.payload,
      };
    case fetchHourlyCSVActions.FETCH_CHECKEREPORT_SUCCESS:
      return {
        ...state,
        checkerReportSuccess: action.payload,
        checkerReportError: null,
      };
    case fetchHourlyCSVActions.FETCH_CHECKEREPORT_FAILURE:
      return {
        ...state,
        checkerReportSuccess: null,
        checkerReportError: action.payload,
      };

    default:
      return state;
  }
};
